function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useQueryClient, useMutation } from 'react-query';
import axios from 'axios';
import { API_PREFIX_URL, CACHE_KEYS } from './config';
var RULES_CONTROLLER = 'tap_question_rules';
var API = {
    create: function() {
        var _ref = _async_to_generator(function(tapSurveyIdentifier, params) {
            var createUrl;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        createUrl = "".concat(API_PREFIX_URL, "/tap_surveys/").concat(tapSurveyIdentifier, "/").concat(RULES_CONTROLLER);
                        return [
                            4,
                            axios.post(createUrl, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(tapSurveyIdentifier, params) {
            return _ref.apply(this, arguments);
        };
    }(),
    update: function() {
        var _ref = _async_to_generator(function(tapSurveyIdentifier, ruleId, params) {
            var updateUrl;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updateUrl = "".concat(API_PREFIX_URL, "/tap_surveys/").concat(tapSurveyIdentifier, "/").concat(RULES_CONTROLLER, "/").concat(ruleId);
                        return [
                            4,
                            axios.patch(updateUrl, params)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(tapSurveyIdentifier, ruleId, params) {
            return _ref.apply(this, arguments);
        };
    }(),
    destroy: function() {
        var _ref = _async_to_generator(function(tapSurveyIdentifier, ruleId) {
            var deleteUrl;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        deleteUrl = "".concat(API_PREFIX_URL, "/tap_surveys/").concat(tapSurveyIdentifier, "/").concat(RULES_CONTROLLER, "/").concat(ruleId);
                        return [
                            4,
                            axios.delete(deleteUrl)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(tapSurveyIdentifier, ruleId) {
            return _ref.apply(this, arguments);
        };
    }()
};
/*
 *  Create Rule
 */ var addNewRule = function() {
    var _ref = _async_to_generator(function(_param) {
        var tapSurveyIdentifier, rest;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    tapSurveyIdentifier = _param.tapSurveyIdentifier, rest = _object_without_properties(_param, [
                        "tapSurveyIdentifier"
                    ]);
                    return [
                        4,
                        API.create(tapSurveyIdentifier, rest)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function addNewRule(_param) {
        return _ref.apply(this, arguments);
    };
}();
export var useAddNewRule = function() {
    var queryClient = useQueryClient();
    return useMutation(addNewRule, {
        onSuccess: function() {
            queryClient.invalidateQueries(CACHE_KEYS.RULESETS);
        }
    });
};
/*
 *  Update Rule
 */ var updateRule = function() {
    var _ref = _async_to_generator(function(_param) {
        var tapSurveyIdentifier, ruleId, rest;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    tapSurveyIdentifier = _param.tapSurveyIdentifier, ruleId = _param.ruleId, rest = _object_without_properties(_param, [
                        "tapSurveyIdentifier",
                        "ruleId"
                    ]);
                    return [
                        4,
                        API.update(tapSurveyIdentifier, ruleId, rest)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function updateRule(_param) {
        return _ref.apply(this, arguments);
    };
}();
export var useUpdateRule = function() {
    var queryClient = useQueryClient();
    return useMutation(updateRule, {
        onSuccess: function() {
            queryClient.invalidateQueries(CACHE_KEYS.RULESETS);
        }
    });
};
/*
 *  Delete Rule
 */ var deleteRule = function() {
    var _ref = _async_to_generator(function(param) {
        var tapSurveyIdentifier, ruleId;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    tapSurveyIdentifier = param.tapSurveyIdentifier, ruleId = param.ruleId;
                    return [
                        4,
                        API.destroy(tapSurveyIdentifier, ruleId)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function deleteRule(_) {
        return _ref.apply(this, arguments);
    };
}();
export var useDeleteRule = function() {
    var queryClient = useQueryClient();
    return useMutation(deleteRule, {
        onSuccess: function() {
            queryClient.invalidateQueries(CACHE_KEYS.RULESETS);
        }
    });
};
